import type { CometDSingleton } from '$lib/services/cometd/cometd.js';
import {
    getMandatoryMessagesEventConverters,
    getPlayerValuablesConverters,
    getSessionConfigurationEventConverters,
    getGameSessionNetFinancialPositionConverters,
    getWalletEventConverters,
    getRealityCheckEventConverters,
    getPersistentNotificationsEventConverters,
    getKycEventConverters,
    getDepositLimitAdjustmentEventConverters,
    getJackpotsEventConverters,
    getSportsEventsConverters,
    getKycNotificationConverters
} from './eventConverters/index';
import { CHANNELS } from '../../cometd/cometd.constants';
import type { TEvent } from '../../cometd/cometd.types';
import { spineBus } from '../MessageBus';
import type { TEventConverterPayloads } from './eventConverters/eventConverter.types';
import { cond } from 'lodash-es';
import type { TPlayerData } from '../../lisService/types';
import type { TCond } from '$src/lib/common';

const subscriptionHandler = (event: TEvent) => {
    const conditions: TCond<TEvent, TEventConverterPayloads>[] = [
        ...getWalletEventConverters(),
        ...getMandatoryMessagesEventConverters(),
        ...getPlayerValuablesConverters(),
        ...getSessionConfigurationEventConverters(),
        ...getGameSessionNetFinancialPositionConverters(),
        ...getJackpotsEventConverters(),
        ...getRealityCheckEventConverters(),
        ...getPersistentNotificationsEventConverters(),
        ...getKycEventConverters(),
        ...getDepositLimitAdjustmentEventConverters(),
        ...getSportsEventsConverters(),
        ...getKycNotificationConverters()
    ];

    const getPayload = cond<TEvent, TEventConverterPayloads>(conditions);
    const payload = getPayload(event);

    if (!payload) return;
    spineBus.publish('external', payload);
};

export const subscribeToCometDPlayerChannelEvents = (
    cometd: CometDSingleton | undefined,
    playerData: TPlayerData | undefined,
    sessionId: string | undefined,
    unsubscribe: VoidFunction = () => {}
): VoidFunction => {
    if (!cometd || !playerData || !sessionId) {
        return unsubscribe;
    } else {
        const playerChannel = `${CHANNELS.PLAYER}/${playerData.playerId}`;
        const playerHandlePromise = cometd.subscribe(playerChannel, subscriptionHandler, {
            sessionId
        });
        return () => playerHandlePromise.then((playerHandle) => cometd.unsubscribe(playerHandle));
    }
};
